<section class="monitoring-preferences" [class.mobile]="mobile" aria-labelledby="monitoring-preferences-title"
  [attr.aria-busy]="loading || saving">
  <div class="section-title"><b id="monitoring-preferences-title">{{'MONITORING_PREFERENCES.TITLE' | translate}}</b></div>
  <div class="fields">
    @if (loading) {
      <p class="section-message" role="status">{{'MONITORING_PREFERENCES.LOADING' | translate}}</p>
    }
    <div class="floors-field first-field" [class.soft-input-card]="mobile">
      <mat-form-field [appearance]="mobile ? 'fill' : 'outline'">
        <mat-label>{{'MONITORING_PREFERENCES.FLOORS' | translate}}</mat-label>
        <mat-select multiple [value]="selectedUnitIds" (selectionChange)="selectUnits($event.value)"
          [disabled]="disabled" [panelClass]="mobile ? 'soft-select-panel' : ''">
          @for (unit of selection?.units || []; track unit.id) {
            <mat-option [value]="unit.id" [disabled]="saving || (draft.size === 1 && draft.has(unit.id))">{{unit.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (selection; as current) {
      @if (current.state === 'NO_ACCESSIBLE_UNITS') {
        <p class="section-message" role="status">{{'MONITORING_PREFERENCES.NO_UNITS' | translate}}</p>
      } @else {
        @if (current.state === 'SELECTION_REQUIRED') {
          <p class="notice section-message" role="status">{{'MONITORING_PREFERENCES.REQUIRED' | translate}}</p>
        }
      }
    }
    @if (notice) { <p class="notice section-message" role="status">{{'MONITORING_PREFERENCES.' + notice | translate}}</p> }
    @if (error) {
      <p class="error section-message" role="alert">{{'MONITORING_PREFERENCES.' + error | translate}}</p>
      @if (!selection || error === 'INVALID_UNITS' || error === 'FORBIDDEN') {
        <div class="section-message"><ion-button type="button" mode="md" fill="outline" (click)="retry()">{{'MONITORING_PREFERENCES.RETRY' | translate}}</ion-button></div>
      }
    }
    @if (saved && showSaveButton) { <p class="success section-message" role="status">{{'MONITORING_PREFERENCES.SAVED' | translate}}</p> }
    @if (showSaveButton && selection && selection.state !== 'NO_ACCESSIBLE_UNITS') {
      <div class="actions section-message">
        <ion-button type="button" mode="md" fill="outline" (click)="save()" [disabled]="!canSave">
          {{(saving ? 'MONITORING_PREFERENCES.SAVING' : 'GENERAL.BUTTONS.SAVE') | translate}}
        </ion-button>
      </div>
    }
  </div>
</section>
